import React, { useState } from 'react'
import { MDBBox, MDBBtn, MDBModal, MDBModalHeader, MDBModalBody, MDBCol, MDBRow, MDBContainer } from 'mdbreact'
import Moment from 'react-moment'
//graphql
import { useQuery, useMutation } from '@apollo/react-hooks'
import COMMENTS_BY_BLOG from '../queries/blog/commentsByBlog'
import CommentsLoading from './loaders/CommentsLoading'
import ADD_REPLY from '../queries/blog/addReply'
import ReCAPTCHA from "react-google-recaptcha";

const Comment = ({blogID}) => {
    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState({
        id: null,
        name: '',
        comment: '',
        createdAt: ''
    })
    const [formData, setFormData] = useState({
        replyName: '',
        replyComment: ''
    })
    const [btn, setBtn] = useState('Leave Reply');
    const [captcha, setCaptcha] = useState(false)
    const { data, loading, error } = useQuery(COMMENTS_BY_BLOG, { variables: { blog: blogID }, pollInterval: 1 })
    const [ addReply ] = useMutation(ADD_REPLY);

    if(loading) return <CommentsLoading/>
    if(error) return <p>{error.message}</p>
    
    const { id, name, comment } = modalData
    const { replyName, replyComment } = formData
    const commentsData = data.comments

    const toggleShow = () => setShow(!show)

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value})
    const errorCaptcha = () => setCaptcha(true)
    const recaptchaRef = React.createRef();

    const replyToComment = (id, name, comment, createdAt) => {
        setModalData({
            id: id,
            name: name,
            comment: comment,
            createdAt: createdAt
        })
        setShow(true);
    }

    const submitReply = e => {
        e.preventDefault();
        const recaptchaValue = recaptchaRef.current.getValue();
        if(recaptchaValue !== null && recaptchaValue !== `undefined` && recaptchaValue.length !== 0){
            if(addReply({ variables: { commentID: id, name: replyName, reply: replyComment } })){
                setBtn(
                    <>
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    </>
                )
                setCaptcha(false);
                setTimeout(()=>{
                    setFormData({
                        replyName: '',
                        replyComment: ''
                    })
                    setBtn('Leave Reply')
                    setTimeout(()=>{
                        setShow(false);
                    },1000)
                },1200)     
            }    
        }
        else{
            errorCaptcha();
        }
    }

    const comments = commentsData.map((comment)=>
        <>
        <MDBBox key={comment.id} className="pt-4 pb-4" display="flex">
            <MDBBox display="flex">
                <div className="comment-avatar">
                    <img 
                    style={{ width: '100px' }}
                    className="rounded-circle"
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcS5g8Rk8M_ot6Qiwb65JifkU2A65AdXGRtZVZbZ9YtR9lGnypAq&usqp=CAU" 
                    alt=""/>  
                </div>              
            <MDBBox flex="column" display="flex" className="ml-3">
                <MDBBox alignItems="center" display="flex" justifyContent="between">
                <div className="comment-author">
                    <h4 className="h4-responsive text-capitalize mb-0 font-weight-bold">
                        {comment.name}
                    </h4>
                </div>
                <div className="comment-reply">
                    <MDBBtn className="mb-0" onClick={()=>replyToComment(comment.id, comment.name, comment.comment, comment.createdAt)} color="grey" outline size="sm">
                    Reply
                    </MDBBtn>
                </div>
                </MDBBox>
                <div className="comment-date mt-0 grey-text">
                <small>
                    <Moment format="MMM DD, YYYY">
                        {comment.createdAt}
                    </Moment>
                    <span>: </span>
                    <Moment fromNow>{comment.createdAt}</Moment>
                </small>    
                </div>
                <div style={{ width: '695px' }} className="comment-content h6-responsive mt-2">
                    {comment.comment}
                </div>
            </MDBBox>
            </MDBBox>
        </MDBBox> 
        {comment.replies && 
            comment.replies.map((reply)=>
                <>
                <div className="pl-5 py-4">
                    <MDBRow>
                        <MDBCol size="4" lg="2" md="2">
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcS5g8Rk8M_ot6Qiwb65JifkU2A65AdXGRtZVZbZ9YtR9lGnypAq&usqp=CAU" alt="" className="w-100 rounded-circle"/>
                        </MDBCol>
                        <MDBCol size="8" lg="10" md="10" className="px-0 align-self-center">
                            <MDBRow>
                                <MDBCol md="12" lg="12">
                                    <h4 className="h4-responsive m-0 text-capitalize font-weight-bold">
                                        {reply.name}
                                    </h4>
                                    <div className="comment-date mt-0 grey-text">
                                        <small>
                                            <Moment format="MMM DD, YYYY">
                                                {reply.createdAt}
                                            </Moment>
                                            <span>: </span>
                                            <Moment fromNow>{reply.createdAt}</Moment>
                                        </small>    
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="12" lg="12">
                                    <div className="h6-responsive mt-2">
                                        {reply.reply}
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>
                    </MDBRow>
                </div>
                </>
            )
        }
        </>
    )
    
    return (
        <>
        <h4 className="h4-responsive font-weight-bold mb-5 mt-5">
            Comments 
            <span className="mx-2" style={{ letterSpacing: '0.4rem' }}>
                {`(${data.comments.length.toString()})`}
            </span>
        </h4>
        <p className="d-md-none d-lg-none">
            You can scroll to the right.
        </p>
        <hr/>
        {data.comments.length === 0 ? (
            <div className="my-4">
                <h4 className="h4-responsive m-0 text-uppercase font-weight-bold text-center">
                    No Comments yet
                </h4>
            </div>
        ) : comments}
        <MDBModal toggle={toggleShow} isOpen={show} centered>
            <MDBModalHeader toggle={toggleShow} style={{ border: 0 }}/>
            <MDBModalBody>
            <div className="p-5">
                <MDBContainer>
                    <h4 className="h4-responsive mb-4 font-weight-bold">
                        Replying to
                    </h4>
                    <section className="grey lighten-4 p-4">
                        <MDBRow>
                            <MDBCol size="4" md="4" lg="4">
                                <img className="w-100 rounded-circle" src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcS5g8Rk8M_ot6Qiwb65JifkU2A65AdXGRtZVZbZ9YtR9lGnypAq&usqp=CAU" alt=""/>
                            </MDBCol>
                            <MDBCol size="8" md="8" lg="8" className="px-0">
                                <MDBRow>
                                    <MDBCol md="12" lg="12">
                                        <h4 className="h4-responsive m-0 text-capitalize font-weight-bold">
                                            {name}
                                        </h4>
                                        <small className="grey-text">
                                            <Moment format="MMM DD, YYYY">
                                                {comment.createdAt}
                                            </Moment>
                                        </small>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="12" lg="12">
                                        <div>
                                            {comment}
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </section>
                <MDBRow className="mt-4">
                    <MDBCol md="12" lg="12">
                        <form onSubmit={(e)=>submitReply(e)}>
                            <input name="replyName" value={replyName} onChange={(e)=>onChange(e)} type="text" required className="form-control form-control-lg input-custom mb-4" placeholder="Your Name" />
                            <textarea name="replyComment" value={replyComment} onChange={(e)=>onChange(e)} rows="5" required type="text" className="form-control form-control-lg input-custom my-4" placeholder="Your Message" />
                            {captcha && <h6 className="red-text h6-responsive mb-3">
                                You need to verify your identity below.
                            </h6>}
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey="6Ld_1cEZAAAAAILqFsxD1yNO4cT5UojHRdhBCLEp"
                                onChange={(value)=>{console.log(value); setCaptcha(false);}}
                            />
                            <MDBBtn type="submit" color="dark" className="text-capitalize mt-4 mx-0">
                                {btn}
                            </MDBBtn>
                        </form>
                    </MDBCol>
                </MDBRow>
                </MDBContainer>
            </div>
            </MDBModalBody>
        </MDBModal>
        </>
    )
}

export default Comment
